import { Alert, Button } from "@mui/material"
import { If } from "lib/@components/switch"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useSearchParam } from "lib/@hooks/use-search-param"
import { skillMapScheduleAssignments } from "routes/skill-mapper/controller/skill-map-schedule-assignments"
import { countAssignmentsByKind, describeAssignmentCounts } from "./describe-assignment-counts"

/**
 * Above the skill routing view (FIQ-2457): anyone editing skill routing needs to know it
 * no longer applies to work that has been assigned directly. Renders nothing when the
 * skill map has no assignments. Plugged into SkillMapSkillRoutingTop behind the flag.
 */
export function ScheduleAssignmentsBanner() {
    const { skillMapId, trades } = useBoundContext()
    const assignments = skillMapScheduleAssignments.useResults({ skillMapId })
    const [, setViewMode] = useSearchParam("skillMapView", "skills")
    const summary = describeAssignmentCounts(countAssignmentsByKind(assignments, { trades }))

    return (
        <If value={!!summary}>
            <Alert
                severity="info"
                data-cy="schedule-assignments-banner"
                action={
                    <Button size="small" color="inherit" onClick={openAssignments}>
                        View assignments
                    </Button>
                }
            >
                {summary} assigned directly to trades. Their tasks ignore the skill routing below.
            </Alert>
        </If>
    )

    function openAssignments() {
        setViewMode("assignments")
    }
}
